<script>
export default {
  name: 'BookmakerJoinButton',
  props: {
    bookmakerId: {
      type: String,
      default: () => '',
    },
    bookmakerLink: {
      type: String,
      default: () => '/',
    },
    headerText: {
      type: String,
      default: () => '',
    },
    detailsText: {
      type: String,
      default: () => '',
    },
  },
};
</script>

<template>
  <div class="bookie-join-button__container">
    <a
      :href="bookmakerLink"
      :class="`bookie-join-button__btn bookmaker-join-${bookmakerId}`"
      target="_blank"
    >
      <div class="bookie-join-button__image"></div>
      <div class="bookie-join-button__btn-txt">
        <div class="bookie-join-button__header-text">{{ headerText }}</div>
        <div class="bookie-join-button__details-text">{{ detailsText }}</div>
      </div>
    </a>
  </div>
</template>
